import { render } from "./CharacterStory.vue?vue&type=template&id=74643554&ts=true"
import script from "./CharacterStory.vue?vue&type=script&lang=ts"
export * from "./CharacterStory.vue?vue&type=script&lang=ts"

import "./CharacterStory.vue?vue&type=style&index=0&id=74643554&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__